const CENT = 0.01;

export const POOL_CAP_OVERFLOW_TO_VENUE = 'stays with the venue';

const destinationsOf = ({ capOverflowRecipients, capOverflowRetained }, { nameFor }) => {
  const destinations = capOverflowRecipients.map((recipient) => {
    const name = nameFor(recipient.performerId) || 'Unnamed artist';
    return { amount: recipient.amount, phrase: `to ${name}`, soleDestination: `goes to ${name}` };
  });
  if (capOverflowRetained >= CENT) {
    destinations.push({ amount: capOverflowRetained, phrase: POOL_CAP_OVERFLOW_TO_VENUE, soleDestination: POOL_CAP_OVERFLOW_TO_VENUE });
  }
  return destinations;
};

export const describeCapOverflow = (member, { nameFor, formatAmount }) => {
  const destinations = destinationsOf(member, { nameFor });
  if (destinations.length === 0) return formatAmount(member.capOverflow);
  const accounted = destinations.reduce((sum, destination) => sum + destination.amount, 0);
  if (destinations.length === 1) return `${formatAmount(accounted)} ${destinations[0].soleDestination}`;
  return `${formatAmount(accounted)} — ${destinations.map((destination) => `${formatAmount(destination.amount)} ${destination.phrase}`).join(', ')}`;
};

export const hasCapOverflow = (member) => Math.round(member.capOverflow * 100) > 0;
